var WINDOW = require('./window');



var Water = {

  ms_Deg2rad: Math.PI / 180,
  ms_Canvas: null,
  ms_Renderer: null,
  ms_Camera: null,
  ms_CameraContainer: null,
  ms_Scene: null,
  ms_Controls: null,
  ms_Water: null,
  ms_HasDeviceOrientation: false,
  startTime: Date.now(),

  turbidityTimer: undefined,
  touchFlg: false,
  changeFlg: false,
  moveFlg: false,
  counter: 0,
  cntMaxVal: 190,
  progress: 0,

  waterColor: {},

  clearWaterFlg: true,
  turbiditingFlg: false,
  startTurbiditingFlg: false,
  endTurbiditingFlg: false,
  timerFlg: false,
  starWaterClearFlg: false,

  ua: undefined,

  timerTime: 7000,


  enable: (function enable() {
    try {
      var aCanvas = document.createElement('canvas');
      return !! window.WebGLRenderingContext && (aCanvas.getContext('webgl') || aCanvas.getContext('experimental-webgl',{alpha: false}));
    }
    catch(e) {
      return false;
    }
  })(),

  init: function(inIdCanvas){
    WINDOW.initialize();
    this.checkUa();
    this.setIntervalTime();
    this.setup(inIdCanvas);
    this.startTime = new Date().getTime();
    this.waterClickable();
  },

  setup: function(inIdCanvas) {
    var me = this;
    this.ms_Canvas = $('#'+inIdCanvas);

    // Initialize Renderer, Camera and Scene
    this.ms_Renderer = this.enable? new THREE.WebGLRenderer() : new THREE.CanvasRenderer();
    this.ms_Renderer.setClearColor( new THREE.Color(0xffffff) );
    this.ms_Canvas.html(this.ms_Renderer.domElement);
    this.ms_Scene = new THREE.Scene();

    this.ms_Camera = new THREE.PerspectiveCamera(5.0, WINDOW.ms_Width / WINDOW.ms_Height, 0.5, 300);
    this.ms_Camera.position.set(50, 50, 0);
    this.ms_Camera.rotation.x = - Math.PI * 0.5;


    //this.ms_Camera = new THREE.OrthographicCamera(WINDOW.ms_Width / -2, WINDOW.ms_Width / 2, WINDOW.ms_Height / 2, WINDOW.ms_Height / -2, 0.1, 300);
    //this.ms_Camera.position.set(0, 0, 10);


    var container = new THREE.Object3D();
    container.add(this.ms_Camera);
    this.ms_Scene.add(container);

    // Add light
    var directionalLight = new THREE.DirectionalLight(0xADEAFF,0.1);
    directionalLight.position.set(0, 10, 0);
    // this.ms_Scene.add(directionalLight);

    // Load textures
    var waterNormals = new THREE.ImageUtils.loadTexture('/assets/img/top/waternormals.jpg'); //wave_01, waternormals
    waterNormals.wrapS = waterNormals.wrapT = THREE.RepeatWrapping;
    // waterNormals.setClearColor( new THREE.Color(0xffffff) );


    // Create the water effect
    this.ms_Water = new THREE.Water(this.ms_Renderer, this.ms_Camera, this.ms_Scene, {
      textureWidth: 256,
      textureHeight: 256,
      waterNormals: waterNormals,
      alpha: 0.7,
      sunDirection: directionalLight.position.set(0, 10, 0).normalize(),
      sunColor: 0xc8eeff, // ecf9ff, a1e2ff, bcddec, 99DFFF
      waterColor: 0x8acfef, // 262b46, 00afee, c0ebff, 2cb5f3
      betaVersion: 0,
      transparent: true
    });

    this.ms_Water.material.blending = THREE.NormalBlending;
    this.ms_Water.material.transparent = true;


    var aMeshMirror = new THREE.Mesh(
      new THREE.PlaneBufferGeometry(500, 500, 1, 1),
      this.ms_Water.material
    );
    aMeshMirror.add(this.ms_Water);
    aMeshMirror.rotation.x = - Math.PI * 0.5;
    //aMeshMirror.rotation.y = - Math.PI * 0.5;
    aMeshMirror.position.y = -1;
    aMeshMirror.position.z = -1;


    this.ms_Scene.add(aMeshMirror);



    this.waterColor = {
      r : this.ms_Water.waterColor.r,
      g : this.ms_Water.waterColor.g,
      b : this.ms_Water.waterColor.b
    };

    this.sunColor = {
      r : this.ms_Water.sunColor.r,
      g : this.ms_Water.sunColor.g,
      b : this.ms_Water.sunColor.b
    };


    // this.loadSkyBox();

    this.scene2 = new THREE.Scene();
    this.camera2 = new THREE.OrthographicCamera(WINDOW.ms_Width / -2, WINDOW.ms_Width / 2, WINDOW.ms_Height/2,WINDOW.ms_Height/-2,0.1,10);
    this.camera2.position.set(0, -10, -10);
    this.camera2.rotation.x = - Math.PI * 0.5;
    this.scene2.add( this.camera2 );

    //var graGeo = new THREE.PlaneGeometry(WINDOW.ms_Width, WINDOW.ms_Height);
    var graGeo = new THREE.PlaneGeometry(200, 200, 64, 64);
    var graMat = new THREE.MeshBasicMaterial({
      side: THREE.DoubleSide,
      map: THREE.ImageUtils.loadTexture('/assets/img/top/wave_01.jpg'),
      transparent: true,
      depthWrite: false
      //blending: THREE.NomarlBlending // NomarlBlending, SubtractiveBlending, AdditiveBlending, MultiplyBlending
    });
    //graMat.opacity = 0.5;
    var graMesh = new THREE.Mesh( graGeo, graMat );
    graMesh.rotation.x = - Math.PI * 0.5;

    graMesh.position.y = -1;
    graMesh.position.z = -1;
    this.scene2.add(graMesh);



    // 濁りシェーダ
    this.turbidityShader = new TurbidityShader(WINDOW.ms_Width, WINDOW.ms_Height);

    this.waterEffGeo = new THREE.PlaneBufferGeometry( 500, 500, 64, 64 );
    this.waterEffMat = new THREE.ShaderMaterial({
      //fragmentShader: this.turbidityShader.fragmentShader,
      //vertexShader: this.turbidityShader.vertexShader,
      //uniforms: this.turbidityShader.uniforms,

      fragmentShader: [
        'uniform float time;',
        'uniform vec2 resolution;',
        'uniform float opacity;',
        'uniform int oct;',


        'varying vec2 vUv;',

        '#define OCTAVES octaves',
        '#define STRETCH 2.0',
        '#define SQUISH 2.5',


        'float rand(vec2 n) {',
          'return fract(sin(dot(n, vec2(13, 5))) * 43758.5453);',
        '}',

        'float noise(vec2 n) {',
          'const vec2 d = vec2(0.0, 1.0);',
          'vec2 b = floor(n), f = smoothstep(vec2(0.0), vec2(1.0), fract(n));',
          'return mix(mix(rand(b), rand(b + d.yx), f.x), mix(rand(b + d.xy), rand(b + d.yy ), f.x), f.y);',
        '}',

        'float fbm(vec2 n) {',
          'float total = 0.0, amplitude = 1.0;',
          'int o = oct;',
          'int i = 0;',
          'for (int i = 0; i < 7; i++) {',
            'total += noise( vec2(n) ) * amplitude;',
            'n += n;',
            'amplitude *= 0.65;',
          '}',
          //'if(o <= 8){',
          //  'for (int i = 0; i < 8; i++) {',
          //    'total += noise( vec2(n) ) * amplitude;',
          //    'n += n;',
          //    'amplitude *= 0.7;',
          //  '}',
          //'}',
          //'else if(o >= 9){',
          //  'for (int i = 0; i < 9; i++) {',
          //    'total += noise( vec2(n) ) * amplitude;',
          //    'n += n;',
          //    'amplitude *= 0.7;',
          //  '}',
          //'}',


          'return total;',
        '}',

        'vec3 tex(vec2 pos) {',
          'vec3 c1 = vec3(0.9, 1.6, 0.4);',
          'vec3 c2 = vec3(0.25, 2.7, 1);',
          'vec3 c3 = vec3(0.28, 0.4, 0.0);',
          'vec3 c4 = vec3(0.36, 1.0, 0.2);',
          'vec3 c5 = vec3(0.2, 0.1, 0.1);',
          'vec3 c6 = vec3(0.4, 0.2, 0.3);',
          'vec2 p = pos;',
          'float q = fbm(p - time * -0.1);',
          'vec2 o1 = p + q + time - p.x - p.y;',
          'vec2 o2 = p + q + (time * 0.003);',
          'vec2 r = vec2( fbm(o1), fbm(o2) );',
          'vec3 c = mix(c1, c2, fbm(p + r)) + mix(c3, c4, r.x) - mix(c5, c6, r.y);',
          'return c;',
        '}',

        'void main(void) {',
          'vec2 p = (gl_FragCoord.xy / resolution *  0.25 - vec2(0.5)) * vec2(resolution.x / resolution.y, -1);',
          'float r = length(p);',
          'float a = atan(p.y, p.x);',
          'vec2 uv = vec2(sin(a * 1.4), cos(a * 0.34)) / pow(r * 2.0, 1.1 + 0.1) + (time / 1000.);',
          'vec3 col = tex(uv);',
          'col.rgb = col.rbg;',
          'float alp = opacity;',
          'if(alp >= 0.95){',
            'alp = 0.95;',
          '}else if(alp < 0.0){',
            'alp = 0.0;',
          '}',
          'gl_FragColor = vec4(col * length(p), alp);',
        '}'
        //'#define f length(fract(q*=m*=.6+.1*d++)-.5)',
        //'vec3 base_color_1 = vec3(114, 135, 158) / 255.;',
        //'float d = 0.;',
        //'vec3 q = vec3(gl_FragCoord.xy / resolution.yy-13., time * .2);',
        //'mat3 m = mat3(-2,-1,2, 3,-2,1, -1,1,3);',
        //'vec3 col = vec3(pow(min(min(f,f),f), 7.)*40.);',
        //'gl_FragColor = vec4(clamp(col + base_color_1, 0.0, 1.0), 1.0);'
      ].join('\n'),

      vertexShader: [
        'varying vec2 vUv;',
        'void main() {',
          'gl_Position = projectionMatrix * modelViewMatrix * vec4( position, .5 );',
        '}'
      ].join('\n'),

      uniforms: {
        time: { type: 'f', value: 0.0 },
        resolution: { type: 'v2', value: new THREE.Vector2(WINDOW.ms_Width, WINDOW.ms_Height * 1.5) },
        opacity: { type: 'f', value: 1.0 },
        oct: { type: 'i', value: 8 }
      },
      transparent: true,
      //depthWrite: false,
      blending: THREE.NomarlBlending // NomarlBlending, SubtractiveBlending, AdditiveBlending, MultiplyBlending
    });

    //this.waterEffMat.opacity = 0.0;
    //this.waterEffMat.visible  = false;

    this.waterEffMesh = new THREE.Mesh( this.waterEffGeo, this.waterEffMat );
    this.waterEffMesh.rotation.x = - Math.PI * 0.5;
    this.waterEffMesh.position.x = -5;
    this.waterEffMesh.position.y = -5;
    this.waterEffMesh.position.z = -5;

    this.ms_Scene.add(this.waterEffMesh);





    WINDOW.resizeCallback = function(inWidth, inHeight) {
      me.resize( inWidth, inHeight );
    };
    this.resize(WINDOW.ms_Width, WINDOW.ms_Height);


    this.mainLoop();
  },

  checkUa: function() {
    this.UA =  navigator.userAgent.indexOf('iPhone') > 0 ||
               navigator.userAgent.indexOf('iPod') > 0 ||
               navigator.userAgent.indexOf('Android') > 0 ? 'SP' : 'PC';
  },


// -----------------------------------------------------------------
// にごり挙動
// -----------------------------------------------------------------

// -----------------------------------------------------------------
// 汚くなるまでのタイマー
// -----------------------------------------------------------------

  setIntervalTime: function() {
    this.timerTime = 7000;
    if (this.UA === 'SP') {
      this.timerTime = 500;
    }
  },


  timer: function() {
    this.timerFlg = true;
    this.touchFlg = false;
    var _this = this;
    this.turbidityTimer = setTimeout(function(){
      _this.counter = 0;
      _this.clearWaterFlg = false;
      _this.turbiditingFlg = true;
    }, this.timerTime);
  },

// -----------------------------------------------------------------
// 水を汚くするための関数
// -----------------------------------------------------------------
  defileWater: function() {
    this.counter++;
    if(this.counter < this.cntMaxVal && !this.endTurbiditingFlg){

      // this.ms_Water.waterColor.r += (0.0001 / 2);
      // this.ms_Water.waterColor.g -= (0.006 / 2);
      // this.ms_Water.waterColor.b -= (0.008 / 2);

      // this.ms_Water.sunColor.r -= (0.0058 / 1);
      // this.ms_Water.sunColor.g -= (0.0058 / 1);
      // this.ms_Water.sunColor.b -= (0.0058 / 1);

      this.ms_Water.waterColor.r += (0.0035 / 2);
      this.ms_Water.waterColor.g += (0.000000001 / 2);
      this.ms_Water.waterColor.b -= (0.01 / 2);

      this.ms_Water.sunColor.r += (0.0005 / 1);
      this.ms_Water.sunColor.g -= (0.0035 / 1);
      this.ms_Water.sunColor.b -= (0.003 / 1);

      // this.waterEffMesh.material.uniforms.opacity.value += 0.005;
      this.waterEffMesh.material.uniforms.oct.value = Math.round( this.waterEffMesh.material.uniforms.oct.value + 0.5 );
      //this.waterEffMesh.material.uniforms.opacity.value += 0.001;
    } else {
      this.turbiditingFlg = false;
      this.counter = 0;
      $('body').addClass('p-top-dirty-letter');
    }
  },

// -----------------------------------------------------------------
// 水をきれいにするための関数
// -----------------------------------------------------------------
  clearWater: function() {
    this.counter++;
    if(this.counter < this.cntMaxVal && this.ms_Water.waterColor.g > this.waterColor.g){
    // if(this.counter < this.cntMaxVal){

      // this.ms_Water.waterColor.r -= (0.0001 / 2);
      // this.ms_Water.waterColor.g += (0.006 / 2);
      // this.ms_Water.waterColor.b += (0.008 / 2);

      // this.ms_Water.sunColor.r += (0.0058 / 1);
      // this.ms_Water.sunColor.g += (0.0058 / 1);
      // this.ms_Water.sunColor.b += (0.0058 / 1);

      this.ms_Water.waterColor.r -= (0.0038 / 2);
      this.ms_Water.waterColor.g -= (0.000000001 / 2);
      this.ms_Water.waterColor.b += (0.01 / 2);

      this.ms_Water.sunColor.r -= (0.0005 / 1);
      this.ms_Water.sunColor.g += (0.0035 / 1);
      this.ms_Water.sunColor.b += (0.003 / 1);
      

      this.waterEffMesh.material.uniforms.oct.value = Math.round( this.waterEffMesh.material.uniforms.oct.value - 0.5 );
    } else {
      this.clearWaterFlg = true;
      this.timerFlg = false;
      this.counter = 0;
      //this.waterEffMesh.material.uniforms.opacity.value = 0.9;
      $('body').removeClass('p-top-dirty-letter');
    }
  },

// -----------------------------------------------------------------
// クリックしたときの挙動
// -----------------------------------------------------------------
  waterClickable: function() {

    var me = this,
        UA =  navigator.userAgent.indexOf('iPhone') > 0 ||
              navigator.userAgent.indexOf('iPod') > 0 ||
              navigator.userAgent.indexOf('Android') > 0 ? 'SP' : 'PC';

    if(UA == 'SP'){
      $('body').on('touchend',function(){
        this.counter = 0;
        clearTimeout(this.turbidityTimer);
        this.turbiditingFlg = false;
        this.touchFlg = true;
        if(this.turbiditingFlg){
          this.timer(); // 濁りきっていない時だけタイマー起動
        }
      }.bind(this));


      $(window).on('devicemotion',function(e){
        var x =  e.originalEvent.accelerationIncludingGravity.x;
        if (x > 5) {
          this.counter = 0;
          clearTimeout(this.turbidityTimer);
          this.turbiditingFlg = false;
          this.touchFlg = true;
          if(this.turbiditingFlg){
            // 濁りきっていない時だけタイマー起動
            this.timer();
          }
        }
      }.bind(this));

    } else {

      $(window).on('click',function(){

        this.counter = 0;
        // clearTimeout(this.turbidityTimer);
        this.turbiditingFlg = false;
        this.touchFlg = true;
        if(this.turbiditingFlg){
          this.timer(); // 濁りきっていない時だけタイマー起動
        }
      }.bind(this));


       $('body').mousemove( function(e){
         if(!this.moveFlg){
           this.moveFlg = true;
           setTimeout(function(){
             $(window).trigger('click');
             me.moveFlg = false;
           }, 10);
         }
       }.bind(this) );

    }

  },




// -----------------------------------------------------------------
// 水の状態をチェック
// -----------------------------------------------------------------
  checkWater: function() {
    if(this.clearWaterFlg && !this.timerFlg){
      this.timer();
    } else if (!this.clearWaterFlg && this.turbiditingFlg){
      // タイマーが終了して濁り開始
      this.defileWater();
    } else if (!this.clearWaterFlg && !this.turbiditingFlg && this.touchFlg) {
      // クリックされて、きれいになるとき
      this.clearWater();
    }
  },

// -----------------------------------------------------------------
// にごり挙動おわり
// -----------------------------------------------------------------


  display: function display() {
    this.ms_Water.render();
    this.ms_Renderer.render(this.ms_Scene, this.ms_Camera);
  },

  mainLoop: function(){
    var me = this;
    requestAnimationFrame(function(){ me.mainLoop(); });
    this.checkWater();
    this.update();
  },

  update: function update() {
    this.ms_Water.material.uniforms.time.value += Math.sin( ((Math.random() * 20) - 5) / 6000 );
    this.waterEffMesh.material.uniforms.time.value = (Date.now() - this.startTime) / 18000;
    this.display();
  },

  resize: function resize(inWidth, inHeight) {
    this.ms_Camera.aspect =  inWidth / inHeight;
    this.ms_Camera.updateProjectionMatrix();
    this.ms_Renderer.setSize(inWidth, inHeight);
    this.ms_Canvas.html(this.ms_Renderer.domElement);
    this.display();
  }
};


var TurbidityShader = function(w, h){
  this.width = w;
  this.height = h;
};
TurbidityShader.prototype = {
  fragmentShader: [
    'uniform float time;',
    'uniform vec2 resolution;',

    '#define OCTAVES 10',
    '#define STRETCH 2.0',
    '#define SQUISH 2.0',

    'float rand(vec2 n) {',
      'return fract(sin(dot(n, vec2(13, 5))) * 43758.5453);',
    '}',

    'float noise(vec2 n) {',
      'const vec2 d = vec2(0.0, 1.0);',
      'vec2 b = floor(n), f = smoothstep(vec2(0.0), vec2(1.0), fract(n));',
      'return mix(mix(rand(b), rand(b + d.yx), f.x), mix(rand(b + d.xy), rand(b + d.yy ), f.x), f.y);',
    '}',

    'float fbm(vec2 n) {',
      'float total = 0.0, amplitude = 1.0;',
      'for (int i = 0; i < OCTAVES; i++) {',
        'total += noise(n) * amplitude;',
        'n += n;',
        'amplitude *= 0.5;',
      '}',
      'return total;',
    '}',

    'vec3 tex(vec2 pos) {',
      'const vec3 c1 = vec3(2,2,2);',
      'const vec3 c2 = vec3(1,2,1);',
      'const vec3 c3 = vec3(1);',
      'const vec3 c4 = vec3(0,0,0);',
      'const vec3 c5 = vec3(.1);',
      'const vec3 c6 = vec3(1.5);',
      'vec2 p = pos;',
      'float q = fbm(p - time * -0.1);',
      'vec2 r = vec2(fbm(p + q + time - p.x - p.y), fbm(p + q + time));',
      'vec3 c = mix(c1, c2, fbm(p + r)) + mix(c3, c4, r.x) - mix(c5, c6, r.y);',
      'return c;',
    '}',

    'void main(void) {',
      'vec2 p = (gl_FragCoord.xy / resolution*0.5 - vec2(0.2)) * vec2(resolution.x/resolution.y, -2);',
      'float r = length(p);',
      'float a = atan(p.y, p.x);',
      'vec2 uv = vec2(sin(a), cos(a))/pow(r, 1.+.1)+(time/5000.);',
      'vec3 col = tex(uv);',
      'col.rgb = col.rbg;',
      'gl_FragColor = vec4(col*length(p),1);',
    '}'
  ].join('\n'),

  vertexShader: [
    'void main() {',
      'gl_Position = projectionMatrix * modelViewMatrix * vec4( position, 1.0 );',
    '}'
  ].join('\n'),

  uniforms: {
    time: { type: 'f', value: 0 },
    resolution: { type: 'v2', value: new THREE.Vector2(this.width, this.height) }
  }
};




module.exports = Water;


//////////////////
// WEBPACK FOOTER
// ./htdocs_dev/_script/components/water/main.js
// module id = 20
// module chunks = 1